import * as types from './Snackbar.types';
import Constants from '../../constants/Constants';

const initialState = {
  type: Constants.SNACKBAR_MESSAGE_TYPES.DEFAULT,
  message: '',
  open: false,
  autoHideDuration: Constants.SNACKBAR_TIMEOUT
};

const snackbar = (state = initialState, action) => {
  switch (action.type) {
    case types.SHOW_SNACKBAR:
      return Object.assign({}, state, action.data, { open: true });

    case types.HIDE_SNACKBAR:
      return Object.assign({}, state, { open: false });

    default:
      return state;
  }
};

export default snackbar;
